import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  // MobileStepper,
  // Paper,
  Snackbar,
  Typography,
  Button,
  Card,
  Divider,
  TextField,
  MenuItem,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Link,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import AppHeader from "../../components/header";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import usePageTitle from "../../pageTitle";

function ProductDetailPage() {
  const [pageTitle, setPageTitle] = useState("WebStore");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [productReference, setProductReference] = useState(null);
  const [campaign, setCampaign] = useState({});
  const [webstore, setWebstore] = useState({});
  const [productName, setProductName] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [productPrice, setProductPrice] = useState(0.0);
  const [productCurrency, setProductCurrency] = useState(null);

  const [index, setActiveStep] = useState(0);
  const [productImageSize, setProductImageSize] = useState(0);

  const [selectedQty, setSelectedQty] = useState(1);
  const [selectedVariants, setSelectedVariants] = useState([]);

  // Function to go to the next picture
  const goToNextPicture = () => {
    if (index === productImageSize - 1) {
      setActiveStep(0);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const goBackToPicture = () => {
    if (index === 0) {
      setActiveStep(productImageSize - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`webstore/products/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setWebstore(result.data.data.product.webstore);
            setCampaign(result.data.data.product.campaign);
            setProductReference(result.data.data.product.reference);
            setProductName(result.data.data.product.title);
            setProductDescription(result.data.data.product.description);
            setProductImages(result.data.data.product.images);
            setProductVariants(result.data.data.product.variants);
            setProductPrice(result.data.data.product.price);
            setProductImageSize(result.data.data.product.images.length);
            setProductCurrency(result.data.data.product.currency);

            setPageTitle(`Laddar Africa | ${result.data.data.product.title}`);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  // function proceed() {
  //   if (productVariants.length > 0) {
  //     if (selectedVariants.length !== productVariants.length) {
  //       setErrMsg("All product option(s) are required.");
  //       setSeverity("error");
  //       setOpen(true);
  //       return false;
  //     }
  //   }

  //   let payload = {};
  //   let xcart = localStorage.getItem(AppConfig.cart_storage_label);
  //   console.log(xcart);

  //   const productToAdd = {
  //     reference: productReference,
  //     name: productName,
  //     quantity: selectedQty,
  //     amount: productPrice,
  //     image: productImageSize > 0 ? productImages[0] : webstore.icon,
  //     variants: selectedVariants,
  //   };

  //   if (xcart === null) {
  //     payload = {
  //       webstore: webstore,
  //       carts: [
  //         {
  //           reference: campaign.reference,
  //           campaign: campaign,
  //           currency: productCurrency,
  //           products: [productToAdd],
  //         },
  //       ],
  //     };
  //   } else {
  //     var xCart = JSON.parse(xcart);
  //     console.log(xCart);
  //     if (xCart.webstore.reference !== webstore.reference) {
  //       payload = {
  //         webstore: webstore,
  //         carts: [
  //           {
  //             reference: campaign.reference,
  //             campaign: campaign,
  //             currency: productCurrency,
  //             products: [productToAdd],
  //           },
  //         ],
  //       };
  //     } else {
  //       let campaignIndex = null;
  //       xCart.carts.every((cart, index) => {
  //         if (cart.reference === campaign.reference) {
  //           campaignIndex = index;
  //         }
  //         return true;
  //       });

  //       if (campaignIndex !== null) {
  //         let prdIndex = null;
  //         xCart.carts[campaignIndex].products.every((prd, index) => {
  //           if (productReference === prd.reference) {
  //             prdIndex = index;
  //           }

  //           return true;
  //         });

  //         if (prdIndex !== null) {
  //           xCart.carts[campaignIndex].products[prdIndex] = productToAdd;
  //         } else {
  //           xCart.carts[campaignIndex].products.push(productToAdd);
  //         }
  //       } else {
  //         xCart.carts.push({
  //           reference: campaign.reference,
  //           campaign: campaign,
  //           currency: productCurrency,
  //           products: [productToAdd],
  //         });
  //       }
  //       payload = xCart;
  //     }
  //   }

  //   console.log(payload);
  //   localStorage.setItem(AppConfig.cart_storage_label, JSON.stringify(payload));
  //   return true;
  // }

  async function addToCart() {
    if (productVariants.length > 0) {
      if (selectedVariants.length !== productVariants.length) {
        setErrMsg("All product option(s) are required.");
        setSeverity("error");
        setOpen(true);
        return false;
      }
    }

    let sessionRef = null;
    let session = localStorage.getItem(AppConfig.session_storage_label);
    console.log(session);
    if (session !== null) {
      sessionRef = JSON.parse(session).reference;
    }

    const payload = {
      webstore: webstore.reference,
      session: sessionRef,
      product: {
        reference: productReference,
        name: productName,
        quantity: selectedQty,
        variants: selectedVariants,
      },
    };

    console.log(payload);

    setShowLoading(true);
    await axios
      .post(`webstore/carts/products/add.json`, payload)
      .then((result) => {
        console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          // Log the session used
          localStorage.setItem(
            AppConfig.session_storage_label,
            JSON.stringify(result.data.data.session),
          );
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  function buy() {
    // const proceeded = proceed();
    // if (proceeded === true) {
    //   // navigate(`/checkout/${webstore.reference}`);
    //   navigate("/cart");
    //   return;
    // }
    navigate(`/ws/cart/${webstore.reference}`);
    return;
  }

  return (
    <>
      <Container>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
        {/* <Box mt={3} textAlign={{ xs: "center", md: "left", lg: "left" }}> */}
        <Box mb={10}>
          <AppBar>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <img
                  // src="https://placehold.co/600x400.png"
                  src={`${AppConfig.api_media_url}${webstore.logo}`}
                  alt="img"
                  width="24px"
                />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {webstore.title}
              </Typography>
              {/* <div>
                <IconButton size="large" color="inherit">
                  <Icon>shopping_cart</Icon>
                </IconButton>
              </div> */}
            </Toolbar>
          </AppBar>
        </Box>
        <AppHeader webstore={webstore} />
        <Box mt={5} mb={5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <Box p={3} align="center">
                <Box sx={{ width: 1 }}>
                  <img
                    // src="https://placehold.co/600x400.png"
                    src={`${AppConfig.api_media_url}${
                      productImageSize > 0
                        ? productImages[index]
                        : webstore.logo
                    }`}
                    alt="img"
                    width="80%"
                  />
                </Box>
                {productImageSize > 1 ? (
                  <Box mt={2}>
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={6} lg={6}>
                        <Box>
                          <Button onClick={goBackToPicture} variant="outlined">
                            <KeyboardArrowLeft />
                          </Button>
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={6} lg={6}>
                        <Box>
                          <Button variant="outlined" onClick={goToNextPicture}>
                            <KeyboardArrowRight />
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  <> </>
                )}
              </Box>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <Card sx={{ height: "100%" }} elevation={2}>
                <Box p={3} sx={{ height: "100%" }}>
                  <Box mb={3}>
                    <Typography variant="caption" fontWeight={100} mt={3}>
                      {productName}
                    </Typography>
                    <Typography variant="h4" fontWeight={600} color="text">
                      <small>{productCurrency}</small>
                      {(productPrice / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </Box>
                  <Divider />
                  <Box my={3}>
                    <Typography variant="caption" fontWeight={500}>
                      Description
                    </Typography>
                    <Box mt={1}>
                      <Typography variant="caption" fontWeight={100} mt={3}>
                        {productDescription}
                      </Typography>
                    </Box>
                  </Box>
                  {productVariants.length > 0 ? (
                    <>
                      <Box mt={5} mb={5}>
                        <Typography variant="caption" fontWeight={500}>
                          Product Options
                        </Typography>
                        <Box mt={2}>
                          <Grid container spacing={3}>
                            {productVariants.map((variant, index) => (
                              <Grid
                                item
                                xs={6}
                                md={4}
                                lg={4}
                                key={`variant_${index}`}
                              >
                                <TextField
                                  fullWidth
                                  select
                                  size="small"
                                  label={`${variant.title}`}
                                  onChange={(e) => {
                                    let optName = "";
                                    productVariants.every((v) => {
                                      if (v.reference === variant.reference) {
                                        v.options.every((o) => {
                                          if (o.reference === e.target.value) {
                                            optName = o.title;
                                          }
                                          return true;
                                        });
                                      }
                                      return true;
                                    });
                                    let temVariants = selectedVariants;
                                    if (temVariants.length === 0) {
                                      const obj = {
                                        reference: variant.reference,
                                        variant_title: variant.title,
                                        option: e.target.value,
                                        option_title: optName,
                                      };
                                      temVariants.push(obj);
                                      setSelectedVariants(temVariants);
                                      return;
                                    }

                                    let exists = null;
                                    for (let [
                                      index,
                                      row,
                                    ] of temVariants.entries()) {
                                      if (row.reference === variant.reference) {
                                        exists = index;
                                        break;
                                      }
                                    }

                                    if (exists !== null) {
                                      temVariants[exists].option =
                                        e.target.value;
                                      temVariants[exists].option_title =
                                        optName;
                                    } else {
                                      const obj = {
                                        reference: variant.reference,
                                        variant_title: variant.title,
                                        option: e.target.value,
                                        option_title: optName,
                                      };
                                      temVariants.push(obj);
                                    }
                                    setSelectedVariants(temVariants);
                                  }}
                                  SelectProps={{
                                    native: false,
                                  }}
                                >
                                  {variant.options.length > 0 &&
                                    variant.options.map((opt, idx) => (
                                      <MenuItem
                                        name={opt.title}
                                        key={`${opt.reference}_${idx}`}
                                        value={opt.reference}
                                      >
                                        {opt.title}
                                      </MenuItem>
                                    ))}
                                </TextField>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </Box>
                      <Divider />
                    </>
                  ) : (
                    <> </>
                  )}
                  <Box mt={5} mb={10}>
                    <Grid container spacing={3}>
                      <Grid item xs={6} md={3} lg={3}>
                        <Box>
                          <TextField
                            value={selectedQty}
                            size="small"
                            type="number"
                            label="Quantity"
                            onChange={(e) =>
                              setSelectedQty(parseInt(e.target.value, 10))
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={9} lg={9}>
                        <Box>
                          <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<Icon>add_shopping_cart</Icon>}
                            onClick={() => addToCart()}
                            sx={{
                              width: {
                                xs: "100%",
                                md: "inherit",
                                lg: "inherit",
                              },
                            }}
                          >
                            ADD
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box mt={5} mb={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={6} md={6} lg={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="large"
                          color="primary"
                          startIcon={<Icon>arrow_back_rounded</Icon>}
                          sx={{ ml: "-8px" }}
                          onClick={() => {
                            window.history.back();
                          }}
                        >
                          Back
                        </Button>
                      </Grid>
                      <Grid item xs={6} md={6} lg={6}>
                        <Button
                          fullWidth
                          variant="contained"
                          color="success"
                          size="large"
                          endIcon={<Icon>arrow_forward_rounded</Icon>}
                          onClick={() => buy()}
                        >
                          CART
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
        <Box mb={10}>&nbsp;</Box>
        {/* <Box mt={5} mb={3} px={3}>
        <Typography variant="h6" fontWeight={400}>
          <img
            // src="https://placehold.co/600x400.png"
            src={`${AppConfig.api_media_url}${webstore.logo}`}
            alt="img"
            width="16px"
          />
          &nbsp; About {webstore.title}
        </Typography>
        <Typography variant="caption" fontWeight={100} mt={3}>
          {campaign.description}
        </Typography>
      </Box> */}
      </Container>
      <CheckoutFooter />
    </>
  );
}

export default ProductDetailPage;
